import {createInfinityClientSignals} from '@pexip/infinity';

export const infinityClientSignals = createInfinityClientSignals([]);
